import { Pipe, PipeTransform } from '@angular/core';
import { NumericType } from '../../../AngularJS/Models/metric';

@Pipe({
  name: 'formatNumericType'
})
export class FormatNumericTypePipe implements PipeTransform {

    transform(value: number, numericType: NumericType): unknown {
        if (!value)
            return;
        if (numericType === NumericType.Time) {
            const hour = (Math.floor(value / 3600) > 99) ? Math.floor(value / 3600) : ("0" + Math.floor(value / 3600)).slice(-2);
            return (hour + ":" + ("0" + Math.floor(value / 60) % 60).slice(-2) + ":" + ("0" + value % 60).slice(-2));
        }
        else if (numericType === NumericType.Percent)
            return `${value}%`
        return value;
    }
}
